<div class="container">
    <div class="login-area">
        <h5>{{'login.title' | translate}}</h5>
        <h6>{{'login.paragraph.topSupportingText' | translate}}</h6>

        <!-- <form [formGroup]="loginForm"  class="ui form"> -->
        <form [formGroup]="loginForm" (ngSubmit)="login2()" class="ui form">
            <div class="col-md-12 col-sm-12">
                <div class="form-group row">
                    <br />
                    <div class="label-email">{{'login.labels.email' | translate}}</div>
                    <input #input formControlName="custEmail" type="text" class="form-control input-sm" placeholder=""
                        [autofocus]>
                    <!--<div [hidden]="custEmail.valid">Required</div>-->
                    <div *ngIf="loginForm.controls['custEmail'].hasError('required') && loginForm.controls['custEmail'].touched"
                        class="alert alert-danger">{{'login.clientValidation.error.emailMsg' | translate}}</div>

                </div>
                <div class="form-group row">
                    <div class="label-pass">{{'login.labels.password' | translate}}</div>
                    <input formControlName="custPass" type="password" class="form-control input-sm" placeholder=""
                        required>
                    <div *ngIf="loginForm.controls['custEmail'].hasError('required') && loginForm.controls['custEmail'].touched"
                        class="alert alert-danger">{{'login.clientValidation.error.passwordMsg' | translate}}</div>
                </div>
                <div class="row moreSpacingOnTop">
                    <div class="col-xs-12 col-sm-4 notAllowed">
                        <button [disabled]="!loginForm.valid" type="submit"
                            class='btn btn-primary btn-main btn-inlineblock btn-green'>{{'login.buttons.login' |
                            translate}}</button>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-xs-12 col-sm-2">
                        <!-- Forgot your password?  <button class="btn btn-link" (click)="reset()">Send Password Reset Email</button> -->
                        {{'login.links.forgotPassword' | translate}} <a class="noDecoration"
                            [routerLink]="['/reset/from/', repId()]">{{'login.links.passwordReset' | translate}}</a>
                    </div>

                </div>
                <br />
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        {{'login.links.didntHaveAccount' | translate}}
                        <a class="noDecoration" [routerLink]="['/createAccount/from/', repId()]">{{'login.links.createAccount' |
                            translate}}</a>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <br />
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
        <p style="color: white"> {{'products.spinner.signingyouin' | translate}}</p>
    </ngx-spinner>